export const ADD_TODO = "ADD_TODO"
export const REMOVE_TODO = "REMOVE_TODO" 
export const TOGGLE_TODO = "TOGGLE_TODO"
export const UPDATE_DISPLAY = "UPDATE_DISPLAY"
export const ADD_TIME = "ADD_TIME"
export const SUB_TIME = "SUB_TIME"
export const START_PAUSE = "START_PAUSE"
export const RESET = "RESET"
export const TIMER = "TIMER"
export const NEW_SESSION = "NEW_SESSION"
export const CALCULATE_BREAKS = "CALCULATE BREAKS"
export const IMPORTANT_MESSAGE = "IMPORTANT_MESSAGE"
export const NEXT_EVENT = "NEXT_EVENT"
export const NEXT_QUOTE = "NEXT_QUOTE"
export const TIMER_START = "TIMER_START"
export const TIMER_TICK = "TIMER_TICK"
export const TIMER_STOP = "TIMER_STOP"
export const CALC_MESSAGE = "CALC_MESSAGE"